import { Type } from 'class-transformer';

export class AccResultDto {
  accId: number;
  accItemId: number;
  project: string;
  @Type(() => Date)
  receivedDate: Date;
  @Type(() => Date)
  dueDate: Date;
  description: string;
  status: string;
  category: string;
  documentCount: number;
  depositStatus: string;
  allowanceCategory: string;
  allowanceSubCategory: string;
  depositReferenceNumber: string;
}
